import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, FormFeedback } from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { registerUser, apiError } from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";

// import images
import logolight from '../../assets/images/logotop.png';
import logodark from '../../assets/images/logotop.png';

import { isGmail } from "../../helpers/authErrors";
import { GmailNotice, PasswordInput } from "./AuthComponents";

const Register = props => {
    document.title = "Registro | TicketControl - Monitor";

    const dispatch = useDispatch();

    // Esta pantalla es para quien NO usa Gmail. Si escriben un Gmail, se les
    // avisa que no necesitan registrarse y se ofrece Google ahí mismo.
    const [usePassword, setUsePassword] = useState(false);
    // El resultado del registro queda guardado en Redux: sin esto, al volver
    // a esta pantalla se vería el éxito o el error de un intento anterior.
    const [submitted, setSubmitted] = useState(false);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .trim()
                .email("Revisa el email: debe tener el formato nombre@ejemplo.com")
                .required("Escribe tu email"),
            password: Yup.string()
                .min(6, "La clave debe tener al menos 6 caracteres")
                .required("Elige una clave"),
        }),
        onSubmit: (values) => {
            setSubmitted(true);
            dispatch(registerUser({ ...values, email: values.email.trim() }));
        }
    });

    const { user, registrationError, googleError, loading } = useSelector(state => ({
        user: state.account.user,
        registrationError: state.account.registrationError,
        // El botón de Google informa sus errores en el estado de login.
        googleError: state.login.error,
        loading: state.account.loading,
    }));

    const created = submitted && user;
    const error = (submitted && registrationError) || googleError;
    const gmailNotice =
        isGmail(validation.values.email) && !usePassword && !validation.values.password;

    useEffect(() => {
        dispatch(apiError(""));
    }, [dispatch]);

    return (
        <div className="bg-pattern" style={{ minHeight: "100vh" }}>
            <div className="bg-overlay"></div>
            <div className="account-pages pt-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={6} md={8} xl={4}>
                            <Card className="mt-5 shadow" style={{ borderRadius: 12, border: "none" }}>
                                <CardBody className="p-4">
                                    <div className="text-center mb-4">
                                        <Link to="/">
                                            <img src={logodark} alt="" height="50" className="auth-logo logo-dark mx-auto" />
                                            <img src={logolight} alt="" height="50" className="auth-logo logo-light mx-auto" />
                                        </Link>
                                        <h4 className="mt-3 mb-1" style={{ fontWeight: 700, color: "#333" }}>Crea tu cuenta</h4>
                                        <p className="text-muted" style={{ fontSize: 14 }}>Con tu email y una clave que elijas</p>
                                    </div>

                                    {created ? (
                                        <div>
                                            <Alert color="success" className="d-flex align-items-center" style={{ borderRadius: 8 }}>
                                                <span className="material-symbols-rounded me-2" style={{ fontSize: 20 }}>check_circle</span>
                                                <div>¡Listo! Tu cuenta fue creada.</div>
                                            </Alert>
                                            <p style={{ fontSize: 14, color: "#333" }}>
                                                Te enviamos un email a <strong style={{ wordBreak: "break-all" }}>{validation.values.email.trim()}</strong>.
                                                Ábrelo y toca el enlace para confirmar que es tuyo.
                                            </p>
                                            <p className="text-muted" style={{ fontSize: 13 }}>
                                                Para ver tu estacionamiento, este mismo email tiene que estar autorizado
                                                en TicketControl: Configuración → Auditoría → Monitor.
                                            </p>
                                            {/* Firebase deja la sesión iniciada al registrarse: no hace falta volver a escribir la clave.
                                                Si todavía no confirmó el email, ahí lo espera la pantalla de confirmación. */}
                                            <Link to="/dashboard" className="d-grid mt-4">
                                                <button
                                                    className="btn btn-primary"
                                                    style={{ borderRadius: 8, padding: "10px", fontWeight: 600, fontSize: 15 }}
                                                >
                                                    <span className="material-symbols-rounded me-1" style={{ fontSize: 18, verticalAlign: "middle" }}>login</span>
                                                    Entrar a Monitor
                                                </button>
                                            </Link>
                                        </div>
                                    ) : (
                                        <>
                                            {error ? (
                                                <Alert color="danger" className="d-flex align-items-center" style={{ borderRadius: 8 }}>
                                                    <span className="material-symbols-rounded me-2" style={{ fontSize: 20 }}>error</span>
                                                    <div>
                                                        {typeof error === "string"
                                                            ? error
                                                            : "No pudimos crear la cuenta. Vuelve a intentarlo en unos minutos."}
                                                    </div>
                                                </Alert>
                                            ) : null}

                                            <Form
                                                className="form-horizontal"
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    if (!gmailNotice) validation.handleSubmit();
                                                    return false;
                                                }}
                                            >
                                                <div className="mb-3">
                                                    <Label className="form-label" style={{ fontWeight: 600, fontSize: 13 }}>
                                                        <span className="material-symbols-rounded me-1" style={{ fontSize: 16, verticalAlign: "middle" }}>mail</span>
                                                        Email
                                                    </Label>
                                                    <Input
                                                        id="email"
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="tu@email.com"
                                                        type="email"
                                                        style={{ borderRadius: 8, padding: "10px 14px" }}
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email || ""}
                                                        invalid={
                                                            validation.touched.email && validation.errors.email ? true : false
                                                        }
                                                    />
                                                    {validation.touched.email && validation.errors.email ? (
                                                        <FormFeedback type="invalid"><div>{validation.errors.email}</div></FormFeedback>
                                                    ) : null}
                                                </div>

                                                {gmailNotice ? (
                                                    <GmailNotice
                                                        title="Con Gmail no necesitas registrarte"
                                                        skipLabel="Prefiero crear una clave"
                                                        onSkip={() => setUsePassword(true)}
                                                    >
                                                        Toca el botón y elige tu cuenta de Gmail, sin crear una clave.
                                                    </GmailNotice>
                                                ) : (
                                                    <>
                                                        <div className="mb-3">
                                                            <Label className="form-label" style={{ fontWeight: 600, fontSize: 13 }}>
                                                                <span className="material-symbols-rounded me-1" style={{ fontSize: 16, verticalAlign: "middle" }}>lock</span>
                                                                Elige una clave para Monitor
                                                            </Label>
                                                            <PasswordInput
                                                                validation={validation}
                                                                placeholder="Mínimo 6 caracteres"
                                                                autoComplete="new-password"
                                                            />
                                                            <div className="text-muted mt-1" style={{ fontSize: 12 }}>
                                                                Es sólo para Monitor. No uses la clave de tu correo.
                                                            </div>
                                                        </div>

                                                        <div className="d-grid mt-4">
                                                            <button
                                                                className="btn btn-primary"
                                                                type="submit"
                                                                disabled={loading}
                                                                style={{ borderRadius: 8, padding: "10px", fontWeight: 600, fontSize: 15 }}
                                                            >
                                                                <span className="material-symbols-rounded me-1" style={{ fontSize: 18, verticalAlign: "middle" }}>person_add</span>
                                                                {loading ? "Creando tu cuenta…" : "Crear cuenta"}
                                                            </button>
                                                        </div>
                                                    </>
                                                )}
                                            </Form>
                                        </>
                                    )}
                                </CardBody>
                            </Card>

                            <div className="mt-4 text-center">
                                <p className="text-white-50" style={{ fontSize: 14 }}>
                                    ¿Ya tienes una cuenta?{" "}
                                    <Link to="/login" className="fw-medium text-primary">Ingresa</Link>
                                </p>
                                <p className="text-white-50" style={{ fontSize: 12 }}>
                                    © {new Date().getFullYear()} TicketControl Monitor - TicketControl Dev
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default Register;
